export interface IFeature {
	id: number;
	feature: string;
	displayTitle: string;
	order: number;
	createdAt: Date;
	updatedAt: Date;
}

export interface IPage {
	id: number;
	page: string;
	displayTitle: string;
	order: number;
	createdAt: Date;
	updatedAt: Date;
	sections: ISection[];
	boStyle?: string;
}

export interface ISection {
	id: number;
	displayTitle: string;
	order: number;
	createdAt: Date;
	updatedAt: Date;
	fieldGroups: IFieldGroup[];
}

export interface IFieldGroup {
	id: number;
	fieldGroup: string;
	order: number;
	displayTitle: string;
	fieldGroupItems: IFieldGroupItem[];
}

export interface IFieldGroupItem {
	id: number;
	key: string;
	type: string;
	displayTitle: string;
	imageId?: number;
	image?: any;
	order: number;
	createdAt: Date;
	updatedAt: Date;
}

export interface ILanguage {
	id: number;
	code: string;
	name: string;
	displayName: string;
	order: number;
	active: boolean;
	createdAt: Date;
	updatedAt: Date;
	deletedAt: Date;
}

export enum filedGroupItemDataType {
	TEXT = 'text',
	IMAGE = 'image',
}

export enum boStyle {
	SINGLE_LANGUAGE_PAGE = 'single-language-page',
	TEXT_AREA = 'text-area',
	PLAN_CARD = 'plan-card',
	RICH_TEXT = 'rich-text',
	STACK_INPUTS = 'stack-inputs',
	FULL_WIDTH_INPUTS = 'full-width-input',
}
